import { useMemo } from 'react';

import { Me, useCurrentUserHook } from '@/store/currentUser/types';
import { useMeQueryRemote } from '@/store/v2';

export const useCurrentUser: useCurrentUserHook = () => {
  const { data, error, loading } = useMeQueryRemote({
    // Dont cache error responses
    errorPolicy: 'none',
  });

  /**
   * The schema types firstname, lastname, language, profileImage and username as nullable while
   * `Me` requires them, so they fall back to an empty string here rather than reaching consumers
   * as undefined. Making `Me` honest about them is follow-up work.
   *
   * Memoized because RootContext passes `user` straight into setCurrentUser from an effect keyed
   * on it — a fresh object every render would loop.
   */
  const user: Me | undefined = useMemo(
    () =>
      data?.me
        ? {
            ...data.me,
            firstname: data.me.firstname ?? '',
            lastname: data.me.lastname ?? '',
            language: data.me.language ?? '',
            profileImage: data.me.profileImage ?? '',
            username: data.me.username ?? '',
          }
        : undefined,
    [data?.me],
  );

  return {
    user,
    error,
    loading,
    loadingFirstTime: loading && !data?.me,
  };
};
